export default __webpack_public_path__ + "static/media/mediumLogo.e0d0af32.png";